import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_MODEL_LISTING,
    ADD_MODEL,
    UPDATE_MODEL,
    DELETE_MODEL,
    EXPORT_MODEL,
    GET_MODEL_DETAILS,
} from "./actionTypes.js";

import {
    getModelListingSuccess,
    getModelListingFail,
    createModelSuccess,
    createModelFail,
    updateModelSuccess,
    updateModelFail,
    deleteModelSuccess,
    deleteModelFail,
    exportModelSuccess,
    exportModelFail,
    getModelDetailsSuccess,
    getModelDetailsFail,
} from "./actions.js";

import {
    modelListingApi,
    updateModelApi,
    deleteModelApi,
    exportModelApi,
    modelDetailsApi,
    addModelApi,
} from "./modelApi.js";

function* fetchModelListing({ payload }) {
    try {
        const response = yield call(modelListingApi, payload);
        yield put(getModelListingSuccess(response));
    } catch (error) {
        yield put(getModelListingFail(error));
    }
}

function* fetchModelDetail({ payload }) {
    try {
        const response = yield call(modelDetailsApi, payload);
        yield put(getModelDetailsSuccess(response));
    } catch (error) {
        yield put(getModelDetailsFail(error));
    }
}

function* createModel({ payload }) {
    try {
        const response = yield call(addModelApi, payload);
        yield put(createModelSuccess(response));
    } catch (error) {
        yield put(createModelFail(error));
    }
}

function* updateModel({ payload }) {
    try {
        const response = yield call(updateModelApi, payload);
        yield put(updateModelSuccess(response));
    } catch (error) {
        yield put(updateModelFail(error));
    }
}

function* deleteModel({ payload }) {
    try {
        const response = yield call(deleteModelApi, payload);
        yield put(deleteModelSuccess(response));
    } catch (error) {
        yield put(deleteModelFail(error));
    }
}

function* exportModel({ payload }) {
    try {
        const response = yield call(exportModelApi, payload);
        yield put(exportModelSuccess(response));
    } catch (error) {
        yield put(exportModelFail(error));
    }
}

function* ModelSaga() {
    yield takeEvery(GET_MODEL_LISTING, fetchModelListing);
    yield takeEvery(GET_MODEL_DETAILS, fetchModelDetail);
    yield takeEvery(ADD_MODEL, createModel);
    yield takeEvery(UPDATE_MODEL, updateModel);
    yield takeEvery(DELETE_MODEL, deleteModel);
    yield takeEvery(EXPORT_MODEL, exportModel);

}

export default ModelSaga
